export const handleChangeDataPageBestSelling = (name, value) => ({
    type: 'CHANGE_DATA_PAGE_BEST_SELLING', name, value
});